import {investments_api} from "@/store/resources"

export default {
    namespaced: true,
    state: {
        filters: {
            period: null,
            group: null
        },
        filters_data: {
            period_list: [
                {name_ru: 'Все время', name_en: 'All time', value: 'all'},
                {name_ru: 'Месяц', name_en: 'Month', value: 'month'},
                {name_ru: 'Пол года', name_en: 'Half year', value: 'half-year'},
                {name_ru: 'Год', name_en: 'Year', value: 'year'},
            ],
        },
        dynamics: {
            dirty: true,
            datasets: [],
            labels: []
        }
    },
    getters: {
        dynamicsData: state => {
            return {datasets: state.dynamics.datasets, labels: state.dynamics.labels}
        },
    },
    actions: {
        async fetchPortfolioDynamics({commit, state, rootState}) {
            try {
                commit('setDynamicsDirty');
                const res = await investments_api.portfolio_dynamics.get({
                    id: rootState.investments.portfolios.current_portfolio.data.id,
                    period: state.filters.period.value
                });
                if (res.body.success) {
                    commit('setDynamics', res.body.data.portfolioDynamics)
                } else {
                    commit('clearDynamics')
                    console.log(res)
                }
            } catch (err) {
                console.log(err)
            }
        }
    },
    mutations: {
        setDynamicsDirty(state) {
            state.dynamics.dirty = true;
        },
        setDynamics(state, dynamics) {
            state.dynamics.datasets = dynamics.data;
            state.dynamics.labels = dynamics.labels;
            state.dynamics.dirty = false;
        },
        setFilter(state, payload) {
            state.filters[payload.name] = payload.value
        },
        clearDynamics(state) {
            state.dynamics.datasets = [];
            state.dynamics.labels = [];
        }
    }
}